module.exports = __webpack_public_path__ + "static/Myconid-daf599707803b97c86f184243075515b.jpg";